<template>
  <v-scale-screen width="1920" height="1080" fullScreen>
  <div class="dish-management">
    <!-- 顶部导航栏 -->
    <div class="header">
      <!-- 左侧品牌区 -->
      <div class="header-left">
        <div class="brand"@click="handleFullScreen" title="点击进入/退出全屏">
          <div class="stall-icon">
            <i class="el-icon-food"></i>
          </div>
          <div class="brand-text" >
            <span class="header-title">花样菜品余量管理</span>
            <span class="header-subtitle">DISH STOCK MANAGEMENT</span>
          </div>
        </div>
      </div>

      <!-- 中间选择区 -->
      <div class="header-center">
        <div class="header-info">
          <span class="info-item">
            {{ currentDate }} {{ currentWeekday }}
          </span>
        </div>
        <div class="header-selects">
          <div class="select-item">
            <!-- <span class="select-label">
              <i class="el-icon-shop"></i> 档口
            </span> -->
            <el-select
              v-model="stallName"
              placeholder="请选择档口"
              class="header-select"
              popper-class="header-select-dropdown"
              @change="handleStallChange"
            >
              <el-option
                v-for="item in stallList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="select-item">
            <!-- <span class="select-label">
              <i class="el-icon-dish"></i> 餐次
            </span> -->
            <el-select
              v-model="mealName"
              placeholder="请选择餐次"
              class="header-select"
              popper-class="header-select-dropdown"
              @change="handleMealChange"
            >
              <el-option
                v-for="item in mealList"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <!-- 右侧操作区 -->
      <div class="header-right">
        <div class="header-actions">
          <el-button type="text" class="header-btn" @click="handleRefresh">
            <i class="el-icon-refresh"></i> 刷新
          </el-button>
          <el-button type="text" class="header-btn logout-btn" @click="handleLogout">
            <i class="el-icon-switch-button"></i> 退出
          </el-button>
        </div>
      </div>
    </div>

    <!-- 菜品卡片列表（菜品多时可通过左右箭头滚动显示） -->
    <div class="dish-cards-wrapper" v-if="dishList.length">
      <div class="scroll-arrow left" @click="scrollDishCards('left')" v-if="dishList.length > 3">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="dish-cards" ref="dishCards">
        <div
          v-for="(dish, index) in dishList"
          :key="index"
          class="dish-card"
          :class="{ active: selectedDishIndex === index, 'sold-out': dish.sold_out === 1 }"
          @click="selectDish(index)"
        >
          <div class="dish-img">
            <img :src="dish.image" :alt="dish.name" />
            <!-- 售罄遮罩：sold_out === 1 时显示 -->
            <div class="sold-out-mask" v-if="dish.sold_out === 1">
              <span class="sold-out-text">售罄</span>
            </div>
          </div>
          <div class="dish-info">
            <div class="dish-name">
              {{ dish.name }}
              <span class="sold-out-tag" v-if="dish.sold_out === 1">已售罄</span>
            </div>
            <div class="dish-stats">
              <div class="stat-item">
                <span class="stat-value">{{ dish.total }}</span>
                <span class="stat-label">总数量</span>
              </div>
              <div class="stat-item">
                <span class="stat-value sold">{{ dish.sold }}</span>
                <span class="stat-label">已售</span>
              </div>
              <div class="stat-item">
                <span class="stat-value remaining">{{ dish.remaining }}</span>
                <span class="stat-label">剩余</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="scroll-arrow right" @click="scrollDishCards('right')" v-if="dishList.length > 3">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>

    <!-- 调整区域 -->
    <div class="adjust-section" v-if="dishList.length">
      <!-- 左侧：调整已售数量 -->
      <div class="adjust-panel">
        <div class="panel-title"><template v-if="selectedDishName"><span class="panel-dish-name">【{{ selectedDishName }}】</span></template>调整已售数量</div>
        <div class="buttons-grid-wrapper">
          <div class="buttons-grid" ref="soldButtons">
            <div
              v-for="(btn, index) in soldButtons"
              :key="'sold-' + index"
              class="adjust-btn sold-btn"
              :class="{ 'is-disabled': isSelectedDishSoldOut }"
              @click="!isSelectedDishSoldOut && adjustSold(btn.value)"
            >
              {{ btn.label }}
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧：设置剩余数量 -->
      <div class="adjust-panel">
        <div class="panel-title"><template v-if="selectedDishName"><span class="panel-dish-name">【{{ selectedDishName }}】</span></template>设置剩余数量</div>
        <div class="buttons-grid-wrapper">
          <div class="buttons-grid" ref="remainButtons">
            <div
              v-for="(btn, index) in filteredRemainButtons"
              :key="'remain-' + index"
              class="adjust-btn remain-btn"
              @click="setRemaining(btn.value)"
            >
              {{ btn.label }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部操作栏 -->
    <div class="footer" v-if="dishList.length">
      <div class="footer-left">
        <div class="tip-icon">💡</div>
        <span class="tip-label">操作提示</span>
        <span class="tip-text">点击红色按钮调整已售数量，点击绿色按钮设置剩余数量</span>
      </div>
      <div class="footer-right">
        <el-button class="sold-out-btn" type="danger" @click="handleSoldOut">
          <i class="el-icon-warning"></i> 售罄
        </el-button>
      </div>
    </div>

    <!-- 空态：无菜品数据时整个区域只显示一条提示 -->
    <div class="empty-state" v-if="!dishList.length">
      <i class="el-icon-warning-outline"></i>
      <span>暂无菜品数据</span>
    </div>
  </div>
  </v-scale-screen>
</template>

<script>
import { getStallAndMeal,getTodayDishes,sellDish,setSoldOut,restoreDish } from '../api/api'

// 餐次缓存有效期：4 小时（测试时临时改为 5 秒，测试完记得改回）
const MEAL_CACHE_DURATION =  4 * 60 * 60 * 1000

// 读取并校验餐次缓存：超过 4 小时（或无时间戳的旧缓存）视为过期，直接清除；
// 返回 { name: 有效餐次名（过期为空）, expired: 是否过期 }
function readMealCache() {
  const name = sessionStorage.getItem('meal_name')
  const savedTime = sessionStorage.getItem('meal_name_time')
  const expired = !!name && (!savedTime || Date.now() - Number(savedTime) >= MEAL_CACHE_DURATION)
  if (expired) {
    sessionStorage.removeItem('meal_name')
    sessionStorage.removeItem('meal_name_time')
  }
  return { name: expired ? '' : (name || ''), expired }
}

export default {
  name: 'DishManagement',
  data() {
    // 进入页面渲染前即校验餐次缓存：过期则清除，保证下拉框不显示过期餐次
    const { name: cachedMealName, expired: mealExpired } = readMealCache()
    return {
      // 档口 / 餐次
      stallList: [],
      mealList: [],
      // 从本地读取上次选择（无则按时间取默认餐次）
      stallName: sessionStorage.getItem('stall_name') || '',
      mealName: cachedMealName,
      mealTime: '',
      // 餐次缓存是否已过期（超过 4 小时，过期后提示用户重新选择）
      mealNameExpired: mealExpired,
      // 页面常开时定时检查餐次缓存的定时器
      mealCacheTimer: null,
      // 精确到 4 小时到点的过期提示定时器
      mealExpireTimer: null,
      // 菜品数据轮询定时器（每 8 秒刷新一次）
      dishesPollTimer: null,
      // 是否处于全屏状态
      fullscreen: false,
      // 日期默认取当天（getTodayDishes 不传 date 时后端也按当天返回）
      currentDate: (() => {
        const d = new Date()
        const m = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return `${d.getFullYear()}-${m}-${day}`
      })(),
      currentWeekday: '星期' + '日一二三四五六'.charAt(new Date().getDay()),
      // 默认图片：菜品 image 为空时兜底
      defaultImage:
        'https://shuwangysa.oss-cn-hangzhou.aliyuncs.com/uploads/20260819/ec502ef7265a0998b3672eab19618627.png',
      selectedDishIndex: 0,
      // 当前选中菜品名称（点击卡片时更新，随 sellDish 传给后端）
      selectedDishName: '',
      dishList: [],
      soldButtons: [
        { label: '-1', value: -1 },
        { label: '-2', value: -2 },
        { label: '-3', value: -3 },
        { label: '-4', value: -4 },
        { label: '-5', value: -5 },
        { label: '-6', value: -6 },
        { label: '-7', value: -7 },
        { label: '-8', value: -8 },
        { label: '-9', value: -9 },
        { label: '-10', value: -10 },
        { label: '-15', value: -15 },
        { label: '-20', value: -20 },
        { label: '-30', value: -30 },
        { label: '-50', value: -50 }
      ],
      remainButtons: [
        { label: '恢复', value: 'restore' },
        { label: '120', value: 120 },
        { label: '90', value: 90 },
        { label: '80', value: 80 },
        { label: '70', value: 70 },
        { label: '60', value: 60 },
        { label: '50', value: 50 },
        { label: '40', value: 40 },
        { label: '30', value: 30 },
        { label: '20', value: 20 },
        { label: '10', value: 10 },
        { label: '5', value: 5 },
        { label: '4', value: 4 },
        { label: '3', value: 3 },
        { label: '2', value: 2 },
        { label: '1', value: 1 }
      ]
    }
  },
  computed: {
    // 当前选中的菜品是否售罄
    isSelectedDishSoldOut() {
      const dish = this.dishList[this.selectedDishIndex]
      return !!(dish && dish.sold_out === 1)
    },
    // 设置剩余数量按钮：数值大于当前菜品总数量的不显示
    filteredRemainButtons() {
      const dish = this.dishList[this.selectedDishIndex]
      const total = dish ? dish.total : 0
      return this.remainButtons.filter(
        (btn) => btn.value === 'restore' || btn.value <= total
      )
    }
  },
  methods: {
    // 切换全屏（点击品牌区标题触发）
    handleFullScreen() {
      const element = document.documentElement
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen()
        }
      }
      this.fullscreen = !this.fullscreen
    },
    // 全屏状态变化时同步（用户按 ESC 退出也能保持按钮状态正确）
    handleFullScreenChange() {
      this.fullscreen = !!document.fullscreenElement
    },
    // 获取档口和餐次选项（后端返回，失败时保留 mock 兜底）
    async getStallAndMealData() {
      try {
        const res = await getStallAndMeal({
          shop_id: sessionStorage.getItem('shop_id') || null
        })
        console.log(res, 'getStallAndMeal')
        const biz = res && res.data && res.data.data
        if (!biz) return

        // 档口列表：后端 item 结构 { id, sort_order, stall_name }
        const stalls = Array.isArray(biz.stalls) ? biz.stalls : []
        if (stalls.length) {
          // 按 sort_order 升序排列
          const sorted = stalls.slice().sort(
            (a, b) => (a.sort_order || 0) - (b.sort_order || 0)
          )
          this.stallList = sorted.map((s) => s.stall_name)
        }

        // 餐次列表：后端 item 结构 { id, meal_name, sort_order }
        const meals = Array.isArray(biz.meals) ? biz.meals : []
        if (meals.length) {
          // 按 sort_order 升序排列；后端无时间字段，time 留空
          const sorted = meals.slice().sort(
            (a, b) => (a.sort_order || 0) - (b.sort_order || 0)
          )
          this.mealList = sorted.map((m) => ({
            id: m.id,
            name: m.meal_name,
            time: m.meal_time || m.time || ''
          }))
        }

        // 档口：优先取本地保存的选择，否则默认第一个
        if (this.stallList.length) {
          this.stallName = this.stallList.includes(this.stallName)
            ? this.stallName
            : this.stallList[0]
        }

        // 餐次：优先本地保存 → 其次按当前时间默认 → 再取第一个
        if (this.mealList.length) {
          const mealNames = this.mealList.map((m) => m.name)
          // 餐次缓存已过期：不自动选择，提示用户重新选择餐次
          if (this.mealNameExpired) {
            this.mealName = ''
            this.mealTime = ''
            return
          }
          const defaultMeal = this.getDefaultMeal()
          let mealName = ''
          if (mealNames.includes(this.mealName)) {
            mealName = this.mealName
          } else if (defaultMeal && mealNames.includes(defaultMeal)) {
            mealName = defaultMeal
          } else {
            mealName = this.mealList[0].name
          }
          this.mealName = mealName
          const target = this.mealList.find((m) => m.name === mealName)
          this.mealTime = (target && target.time) || ''
        }

        // 选中后同步到本地，便于刷新后恢复
        if (this.stallName) sessionStorage.setItem('stall_name', this.stallName)
        // 餐次：仅当本地没有有效缓存（本次是自动判断/兜底选中的）时才写入并记录时间戳，
        // 已有有效缓存时直接沿用，避免每次进入页面刷新有效期
        if (this.mealName && !sessionStorage.getItem('meal_name')) {
          this.saveMealCache(this.mealName)
          // 自动判断/兜底选中的餐次也要安排过期提示（mounted 时缓存尚未写入）
          this.rescheduleMealExpireTip()
        }

        // 档口/餐次确定后，加载对应菜品数据
        this.getTodayDishesData()
      } catch (e) {
        console.error('获取档口餐次失败：', e)
      }
    },
    // 获取今日菜品（参数 shop_id、stall_name、meal_name、date 可不传取当天）
    async getTodayDishesData() {
      try {
        const params = {
          shop_id: sessionStorage.getItem('shop_id') || null,
          stall_name: this.stallName || null,
          meal_name: this.mealName || null,
          date:this.currentDate
        }
        const res = await getTodayDishes(params)
        console.log(res, 'getTodayDishes')
        const biz = res && res.data && res.data.data
        if (!biz) return

        // 后端菜品数组 dishes（每项 { dish_name, image, initial_quantity, price,
        // remaining_quantity, sold_out, sold_quantity, stock_record_id }）
        // 映射为页面使用的 dishList 结构
        const dishes = biz.dishes
        if (Array.isArray(dishes)) {
          if (dishes.length) {
            this.dishList = dishes.map((d) => ({
              name: d.dish_name || d.name || '未知菜品',
              image: d.image || this.defaultImage,
              // initial_quantity：总数量
              total: d.initial_quantity != null ? d.initial_quantity : 0,
              // sold_quantity：售卖数量
              sold: d.sold_quantity != null ? d.sold_quantity : 0,
              // remaining_quantity：剩余数量
              remaining:
                d.remaining_quantity != null ? d.remaining_quantity : 0,
              // sold_out：1 表示售罄
              sold_out: d.sold_out
            }))
            // 刷新后保持当前选中菜品：按名称匹配新列表，匹配不到才回退到第一个
            let keepIndex = 0
            if (this.selectedDishName) {
              const found = this.dishList.findIndex(
                (d) => d.name === this.selectedDishName
              )
              keepIndex = found >= 0 ? found : 0
            }
            this.selectedDishIndex = keepIndex
            this.selectedDishName = this.dishList[keepIndex].name
          } else {
            // 无菜品数据：清空列表，页面三个区域显示"暂无菜品数据"
            this.dishList = []
            this.selectedDishIndex = 0
            this.selectedDishName = ''
          }
        }
      } catch (e) {
        // 请求失败时保留页面内置的 mock 数据兜底
        console.error('获取今日菜品失败：', e)
      }
    },
    // 根据当前时间返回默认餐次：5-9 点早餐，10-14 点午餐，16-21 点晚餐
    getDefaultMeal() {
      const hour = new Date().getHours()
      if (hour >= 5 && hour < 10) return '早餐'
      if (hour >= 10 && hour < 15) return '午餐'
      if (hour >= 16 && hour < 22) return '晚餐'
      return ''
    },
    // 保存餐次选择并记录时间戳（4 小时后过期清除）
    saveMealCache(name) {
      if (!name) return
      sessionStorage.setItem('meal_name', name)
      sessionStorage.setItem('meal_name_time', String(Date.now()))
    },
    // 检查餐次缓存是否超过 4 小时，过期则清除并提示用户重新选择；返回是否过期
    checkMealCache() {
      const { name, expired } = readMealCache()
      if (expired) {
        this.mealName = name
        this.mealNameExpired = true
      }
      return expired
    },
    // 页面常开时定时检查餐次缓存，4 小时后自动清除并提示（兜底）
    startMealCacheTimer() {
      if (this.mealCacheTimer) return
      this.mealCacheTimer = setInterval(() => {
        if (this.checkMealCache()) {
          clearInterval(this.mealCacheTimer)
          this.mealCacheTimer = null
          this.$message.warning('餐次选择已过期，请重新选择餐次')
        }
      }, 10 * 1000)
    },
    // 计算餐次缓存剩余有效毫秒数（无缓存/已过期返回 0）
    getMealCacheRemain() {
      const name = sessionStorage.getItem('meal_name')
      const savedTime = sessionStorage.getItem('meal_name_time')
      if (!name || !savedTime) return 0
      const remain = MEAL_CACHE_DURATION - (Date.now() - Number(savedTime))
      return remain > 0 ? remain : 0
    },
    // 按剩余时间精确到点触发过期提示（页面常开不刷新也能到点提示）
    scheduleMealExpireTip() {
      if (this.mealExpireTimer) return
      const remain = this.getMealCacheRemain()
      if (remain <= 0) {
        // 已过期：立即清除并提示
        if (this.checkMealCache()) {
          this.$message.warning('餐次选择已过期，请重新选择餐次')
        }
        return
      }
      this.mealExpireTimer = setTimeout(() => {
        this.mealExpireTimer = null
        if (this.checkMealCache()) {
          this.$message.warning('餐次选择已过期，请重新选择餐次')
        }
      }, remain)
    },
    // 用户重新选择餐次后，取消旧定时并按新有效期重新安排
    rescheduleMealExpireTip() {
      if (this.mealExpireTimer) {
        clearTimeout(this.mealExpireTimer)
        this.mealExpireTimer = null
      }
      this.scheduleMealExpireTip()
    },
    handleStallChange() {
      if (this.stallName) sessionStorage.setItem('stall_name', this.stallName)
      this.$message.success(`已切换到 ${this.stallName}`)
      // 切换档口后刷新菜品
      this.getTodayDishesData()
    },
    handleMealChange(val) {
      const target = this.mealList.find((m) => m.name === val)
      this.mealTime = (target && target.time) || ''
      if (val) {
        // 用户手动选择：写入缓存并重新记录 4 小时有效期
        this.saveMealCache(val)
        this.mealNameExpired = false
        // 重新安排 4 小时后的过期提示
        this.rescheduleMealExpireTip()
      }
      this.$message.success(`已切换到 ${val}`)
      // 切换餐次后刷新菜品
      this.getTodayDishesData()
    },
    handleLogout() {
      this.$confirm('确定退出登录吗？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        // type: 'warning',
        customClass: 'logout-confirm-box'
      })
        .then(() => {
          // 退出时清空本地存储
          sessionStorage.removeItem('token')
          sessionStorage.removeItem('shop_id')
          sessionStorage.removeItem('stall_name')
          sessionStorage.removeItem('meal_name')
          sessionStorage.removeItem('meal_name_time')
          this.$router.replace('/loginMenu')
        })
        .catch(() => {})
    },
    selectDish(index) {
      this.selectedDishIndex = index
      // 同步当前选中菜品名称
      const dish = this.dishList[index]
      if (dish) {
        this.selectedDishName = dish.name
      }
    },
    adjustSold(value) {
      const dish = this.dishList[this.selectedDishIndex]
      const count = Math.abs(value)
      const newSold = dish.sold + count
      if (newSold > dish.total) {
        this.$message.warning('已售数量不能超过总数量')
        return
      }
      // 调用后端接口：count 为本次增加的售卖数量
      const params = {
        shop_id: sessionStorage.getItem('shop_id') || null,
        stall_name: this.stallName || null,
        meal_name: this.mealName || null,
        dish_name: this.selectedDishName || dish.name,
        date: this.currentDate
      }
      sellDish({ count, ...params })
        .then((res) => {
          console.log(res, 'sellDish')
          dish.sold = newSold
          dish.remaining = dish.total - newSold
          // 剩余为 0 时立即标记售罄，无需刷新
          dish.sold_out = newSold >= dish.total ? 1 : 0
          this.$message.success('操作成功')
        })
        .catch(() => {
          this.$message.error('设置失败，请重试')
        })
    },
    setRemaining(value) {
      const dish = this.dishList[this.selectedDishIndex]
      // 数值校验
      if (typeof value === 'number' && (value > dish.total || value < 0)) {
        this.$message.warning('剩余数量不能超过总数量或小于 0')
        return
      }
      // 'restore' 表示恢复为总数量，数值表示恢复为指定数量
      const remaining = value === 'restore' ? dish.total : value
      const params = {
        shop_id: sessionStorage.getItem('shop_id') || null,
        stall_name: this.stallName || null,
        meal_name: this.mealName || null,
        dish_name: this.selectedDishName || dish.name,
        date: this.currentDate,
        remaining_quantity: remaining
      }
      restoreDish(params)
        .then((res) => {
          console.log(res, 'restoreDish')
          dish.remaining = remaining
          dish.sold = dish.total - remaining
          dish.sold_out = remaining > 0 ? 0 : 1
          this.$message.success('操作成功')
        })
        .catch(() => {
          this.$message.error('设置失败，请重试')
        })
    },
    handleSoldOut() {
      const dish = this.dishList[this.selectedDishIndex]
      const params = {
        shop_id: sessionStorage.getItem('shop_id') || null,
        stall_name: this.stallName || null,
        meal_name: this.mealName || null,
        dish_name: this.selectedDishName || dish.name,
        date: this.currentDate
      }
      setSoldOut(params)
        .then((res) => {
          console.log(res, 'setSoldOut')
          dish.sold_out = 1 // 立即触发售罄样式
          dish.sold = dish.total
          dish.remaining = 0
          this.$message.success('操作成功')
        })
        .catch(() => {
          this.$message.error('标记售罄失败，请重试')
        })
    },
    handleRefresh() {
      this.$message.info('数据已刷新')
      // 重新请求档口/餐次与今日菜品数据（getStallAndMealData 内部会再拉取菜品），重新渲染页面
      this.getStallAndMealData()
    },
    scrollDishCards(direction) {
      const container = this.$refs.dishCards
      const scrollAmount = 500
      if (direction === 'right') {
        container.scrollLeft += scrollAmount
      } else {
        container.scrollLeft -= scrollAmount
      }
    }
  },
  created() {
    // 统一优化本页面提示框：下移避开顶部档口/餐次选择区，并缩短显示时长
    const rawMsg = this.$message
    const tipConfig = { offset: 115, duration: 500 }
    this.$message = (opts) => {
      const options = typeof opts === 'string' ? { message: opts } : opts || {}
      return rawMsg({ ...tipConfig, ...options })
    }
    ;['success', 'warning', 'error', 'info'].forEach((type) => {
      this.$message[type] = (msg, opts) =>
        rawMsg({ ...tipConfig, message: msg, type, ...(opts || {}) })
    })
  },
  mounted() {
    // 未获取到 shop_id 时退出到档口选择页
    if (!sessionStorage.getItem('shop_id')) {
      this.$router.replace('/loginMenu')
      return
    }
    // 检查餐次缓存是否超过 4 小时，过期则清除并提示用户重新选择
    if (this.checkMealCache() || this.mealNameExpired) {
      this.$message.warning('餐次选择已过期，请重新选择餐次')
    } else {
      // 未过期：按剩余时间精确到点自动提示（页面常开不刷新也能触发）
      this.scheduleMealExpireTip()
    }
    // 每分钟兜底检查一次，保证即使定时器异常也能自动清除并提示
    this.startMealCacheTimer()
    // 加载档口和餐次选项
    this.getStallAndMealData()
    // 每 8 秒轮询刷新今日菜品数据
    this.dishesPollTimer = setInterval(() => {
      this.getTodayDishesData()
    }, 8 * 1000)
    // 监听全屏状态变化（用户按 ESC 退出时同步状态）
    document.addEventListener('fullscreenchange', this.handleFullScreenChange)
  },
  beforeDestroy() {
    if (this.mealCacheTimer) {
      clearInterval(this.mealCacheTimer)
      this.mealCacheTimer = null
    }
    if (this.mealExpireTimer) {
      clearTimeout(this.mealExpireTimer)
      this.mealExpireTimer = null
    }
    if (this.dishesPollTimer) {
      clearInterval(this.dishesPollTimer)
      this.dishesPollTimer = null
    }
    document.removeEventListener('fullscreenchange', this.handleFullScreenChange)
  }
}
</script>

<style scoped>
.dish-management {
  width: 1920px;
  height: 1080px;
  background: #f0f2f5;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 顶部导航 */
.header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #16213e 0%, #1a1a2e 45%, #16213e 100%);
  color: #fff;
  padding: 0 56px;
  height: 128px;
  flex-shrink: 0;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
  z-index: 5;
}

/* 底部金色装饰线 + 左右光晕 */
.header::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 4px;
  background: linear-gradient(90deg, transparent, #f5a623 20%, #ffd080 50%, #f5a623 80%, transparent);
}

.header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 720px;
  height: 128px;
  background: radial-gradient(ellipse at center top, rgba(245, 166, 35, 0.18), transparent 70%);
  pointer-events: none;
}

.header-left {
  display: flex;
  align-items: center;
}

/* 品牌区 */
.brand {
  display: flex;
  align-items: center;
  gap: 22px;
}

.stall-icon {
  width: 76px;
  height: 76px;
  background: linear-gradient(135deg, #f7b733, #f5a623);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: #fff;
  box-shadow: 0 8px 20px rgba(245, 166, 35, 0.4);
}

.brand-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
  user-select: none;
}

.header-title {
  font-size: 40px;
  font-weight: 700;
  letter-spacing: 4px;
  line-height: 1.2;
  background: linear-gradient(90deg, #fff, #ffe8bd);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.header-subtitle {
  font-size: 16px;
  letter-spacing: 5px;
  color: rgba(255, 255, 255, 0.45);
  font-weight: 400;
}

/* 中间选择区 */
.header-center {
  display: flex;
  align-items: center;
  gap: 24px;
}

.header-selects {
  display: flex;
  align-items: center;
  gap: 28px;
}

.select-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.select-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.7);
  white-space: nowrap;
}

.select-label i {
  color: #f5a623;
}

.header-select {
  width: 250px;
}

.header-select ::v-deep .el-input__inner {
  height: 70px;
  line-height: 70px;
  font-size: 34px;
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 12px;
  transition: all 0.25s ease;
}

.header-select ::v-deep .el-input__inner:hover {
  border-color: rgba(245, 166, 35, 0.6);
  background: rgba(255, 255, 255, 0.12);
}

.header-select ::v-deep .el-input__inner:focus {
  border-color: #f5a623;
  background: rgba(245, 166, 35, 0.12);
  box-shadow: 0 0 0 3px rgba(245, 166, 35, 0.15);
}

.header-select ::v-deep .el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.55);
}

.header-select ::v-deep .el-input__suffix {
  color: #fff;
}

.header-select ::v-deep .el-select__caret {
  color: #f5a623;
  font-size: 22px;
}

/* 右侧信息与操作区 */
.header-right {
  display: flex;
  align-items: center;
  gap: 32px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 24px;
  border-radius: 12px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
}

.info-item i {
  color: #f5a623;
}

.info-item.meal {
  padding-left: 14px;
  border-left: 1px solid rgba(255, 255, 255, 0.16);
  color: #ffd080;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-btn {
  color: rgba(255, 255, 255, 0.75) !important;
  font-size: 28px;
  padding: 12px 26px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18) !important;
  transition: all 0.25s ease;
}

.header-btn:hover {
  color: #fff !important;
  background: rgba(255, 255, 255, 0.18);
  border-color: rgba(255, 255, 255, 0.35) !important;
  transform: translateY(-1px);
}

.header-btn i {
  margin-right: 6px;
  font-size: 30px;
}

/* 退出按钮：与普通按钮区分，偏红色 */
.header-btn.logout-btn {
  color: #ffb3b3 !important;
  background: rgba(245, 108, 108, 0.12);
  border-color: rgba(245, 108, 108, 0.4) !important;
}

.header-btn.logout-btn:hover {
  color: #fff !important;
  background: rgba(245, 108, 108, 0.75);
  border-color: rgba(245, 108, 108, 0.9) !important;
}

/* 菜品卡片区域（菜品多时可左右滚动显示） */
.dish-cards-wrapper {
  position: relative;
  background: #fff;
  margin: 24px 48px;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

/* 空态：无菜品数据时整个区域只显示一条提示 */
.empty-state {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 24px 48px;
  background: #fff;
  border-radius: 16px;
  color: #b0b8c4;
  font-size: 40px;
  letter-spacing: 2px;
}

.empty-state i {
  font-size: 72px;
  margin-bottom: 20px;
  color: #c8d0db;
}

.dish-cards {
  display: flex;
  gap: 24px;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 4px 56px;
  scrollbar-width: none;
}

.dish-cards::-webkit-scrollbar {
  display: none;
}

.dish-card {
  display: flex;
  align-items: center;
  gap: 22px;
  min-width: 460px;
  padding: 20px 28px;
  border: 2px solid #e8e8e8;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.25s ease;
}

.dish-card:hover {
  border-color: #409eff;
}

.dish-card.active {
  border-color: #409eff;
  border-width: 5px; /* 原 2px，增至 2.5 倍，突出当前选中 */
  background: #f0f7ff;
}

.dish-img {
  position: relative;
  flex-shrink: 0;
}

.dish-img img {
  width: 104px;
  height: 104px;
  border-radius: 12px;
  object-fit: cover;
}

/* 售罄遮罩：盖在菜品图上 */
.sold-out-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background: rgba(21, 87, 48, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.sold-out-text {
  font-size: 24px;
  font-weight: 900;
  color: #ffffff;
  background: #e43c2a;
  padding: 6px 18px;
  border-radius: 10px;
  letter-spacing: 4px;
  transform: rotate(-8deg);
  box-shadow: 0 4px 12px rgba(228, 60, 42, 0.45);
}

/* 售罄卡片整体置灰：灰色背景，去掉红色边框 */
.dish-card.sold-out {
  border-color: #e5e5e5;
  background: #f5f5f5;
}

/* 售罄但处于选中状态：保留选中高亮样式 */
.dish-card.active.sold-out {
  border-color: #409eff;
  background: #f0f7ff;
}

.dish-card.sold-out .dish-img img {
  filter: grayscale(0.8);
}

.dish-card.sold-out .dish-name {
  color: #b5b5b5;
}

.dish-card.sold-out .stat-value,
.dish-card.sold-out .stat-label {
  color: #c0c4cc;
}

/* 菜名旁的"已售罄"小标签 */
.sold-out-tag {
  display: inline-block;
  margin-left: 10px;
  font-size: 20px;
  font-weight: 600;
  color: #e43c2a;
  background: rgba(228, 60, 42, 0.08);
  border: 1px solid #e43c2a;
  border-radius: 6px;
  padding: 2px 10px;
  vertical-align: 4px;
}

.dish-info {
  flex: 1;
}

.dish-name {
  font-size: 32px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
}

.dish-stats {
  display: flex;
  gap: 40px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-value {
  font-size: 40px;
  font-weight: 700;
  color: #303133;
}

.stat-value.sold {
  color: #409eff;
}

.stat-value.remaining {
  color: #67c23a;
}

.stat-label {
  font-size: 22px;
  color: #909399;
  margin-top: 4px;
}

/* 滚动箭头 */
.scroll-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 52px;
  height: 52px;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.2s;
  font-size: 24px;
}

.scroll-arrow:hover {
  border-color: #409eff;
  color: #409eff;
}

.scroll-arrow.left {
  left: 8px;
}

.scroll-arrow.right {
  right: 8px;
}

/* 调整区域 */
.adjust-section {
  display: flex;
  gap: 24px;
  margin: 0 48px 24px;
  flex: 1;
  min-height: 0;
}

.adjust-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  padding: 28px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  min-height: 0;
}

.panel-title {
  font-size: 26px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 24px;
}

.panel-dish-name {
  color: #409eff;
}

.buttons-grid-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-height: 0;
}

.buttons-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  overflow-x: auto;
  padding: 4px 0;
  flex: 1;
  align-content: flex-start;
}

.buttons-grid::-webkit-scrollbar {
  display: none;
}

.adjust-btn {
  min-width: 120px;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 34px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
  border: 2px solid;
  flex: 1 1 120px;
}

.sold-btn {
  color: #f56c6c;
  border-color: #fbc4c4;
  background: #fff;
}

.sold-btn:hover {
  background: #fef0f0;
  border-color: #f56c6c;
}

.sold-btn:active {
  background: #f56c6c;
  color: #fff;
}

/* 售罄时调整已售按钮禁用态 */
.adjust-btn.sold-btn.is-disabled,
.adjust-btn.sold-btn.is-disabled:hover,
.adjust-btn.sold-btn.is-disabled:active {
  color: #c0c4cc;
  background: #f5f7fa;
  border-color: #e4e7ed;
  box-shadow: none;
  cursor: not-allowed;
  transform: none;
}

.remain-btn {
  color: #67c23a;
  border-color: #c2e7b0;
  background: #fff;
}

.remain-btn:hover {
  background: #f0f9eb;
  border-color: #67c23a;
}

.remain-btn:active {
  background: #67c23a;
  color: #fff;
}

/* 底部操作栏 */
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  margin: 0 48px 40px;
  padding: 20px 40px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

.footer-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tip-icon {
  font-size: 30px;
}

.tip-label {
  font-size: 22px;
  font-weight: 600;
  color: #f5a623;
}

.tip-text {
  font-size: 20px;
  color: #909399;
}

.footer-right {
  display: flex;
  gap: 12px;
}

.sold-out-btn {
  padding: 16px 56px;
  font-size: 30px;
  font-weight: 600;
  border-radius: 10px;
  letter-spacing: 2px;
}

.sold-out-btn i {
  margin-right: 4px;
}

/* 适配说明 */
/* 页面固定以 1920x1080 设计稿渲染，由外层 v-scale-screen 组件自动等比缩放适配各分辨率屏幕 */
</style>

<style>
/* 档口/餐次下拉面板选项字体放大（面板渲染在 body 下，需非 scoped 样式） */
.header-select-dropdown .el-select-dropdown__item {
  height: 66px;
  line-height: 66px;
  padding: 0 32px;
  font-size: 32px;
}

.header-select-dropdown .el-select-dropdown__item.hover,
.header-select-dropdown .el-select-dropdown__item:hover {
  background: #f5f7fa;
}

/* 全局操作提示框：文字放大 */
.el-message {
  min-width: 480px;
  padding: 18px 24px;
  border-radius: 12px;
}

.el-message .el-message__content {
  font-size: 28px;
}

.el-message .el-icon-success,
.el-message .el-icon-error,
.el-message .el-icon-warning {
  font-size: 30px;
}

/* 退出确认弹窗：字体和按钮放大 */
.logout-confirm-box {
  border-radius: 16px;
}

.logout-confirm-box .el-message-box__header {
  padding: 20px 24px 8px;
}

.logout-confirm-box .el-message-box__title {
  font-size: 30px;
}

.logout-confirm-box .el-message-box__content {
  padding: 18px 24px 12px;
}

.logout-confirm-box .el-message-box__message {
  font-size: 28px;
  line-height: 1.5;
}

.logout-confirm-box .el-message-box__status {
  font-size: 42px;
  transform: translateY(-2px);
}

.logout-confirm-box .el-message-box__btns {
  padding: 12px 24px 22px;
}

.logout-confirm-box .el-message-box__btns .el-button {
  height: 54px;
  padding: 0 30px;
  font-size: 26px;
  border-radius: 10px;
}
</style>
